import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import VideocamIcon from '@mui/icons-material/Videocam';
import { HeroType } from '../../types';

interface HeroTypeToggleProps {
  value: HeroType;
  onChange: (type: HeroType) => void;
}

export function HeroTypeToggle({ value, onChange }: HeroTypeToggleProps) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, newValue) => newValue && onChange(newValue)}
      sx={{ mb: 3 }}
    >
      <ToggleButton value="image" sx={{ px: 3 }}>
        <ImageIcon sx={{ mr: 1 }} />
        Bild
      </ToggleButton>
      <ToggleButton value="video" sx={{ px: 3 }}>
        <VideocamIcon sx={{ mr: 1 }} />
        Video
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
